/** Evergreen inquiry CTA — no dated offer or registration embed (WD-01). */
export const activeOffer = {
  status: 'inquiry',
  label: 'Inquire about upcoming programs',
  destination: '/contact',
  nextStep: "We'll reply to your inquiry.",
  fallbackMailto: 'mailto:info@datarook.com',
  partnerLabel: 'Partner With Us',
  archive: {
    name: 'footyLab World Cup Camp',
    dates: 'July 8-10, 2026',
    location: 'Sacred Heart, Knoxville, TN',
    ran: true,
    thankYou:
      'This camp has ended. Thank you to everyone who joined us for a week inside the World Cup.',
  },
};

/** @deprecated Prefer activeOffer.label */
export const INQUIRY_CTA_LABEL = activeOffer.label;
/** @deprecated Prefer activeOffer.destination */
export const INQUIRY_PATH = activeOffer.destination;
/** @deprecated Prefer activeOffer.nextStep */
export const INQUIRY_REPLY_COPY = activeOffer.nextStep;
